import { useClassName } from '@/styles/JwVideoArticle';
import { ComponentProps } from '@/types/component';

import { Component } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export interface VideoArticleUnmuteLabelProps extends ComponentProps<'span'> {}

export const VideoArticleUnmuteLabelComponent: Component<VideoArticleUnmuteLabelProps> = ({ children, ...props }) => {
  const className = useClassName('unmute_label', props);

  return <span {...mergeProps({ className }, props)}>{children}</span>;
};
